enum CampaignQuestionType {
  CUSTOM = 0,
  ADDRESS = 1,
  EMAIL = 2,
  PHONE_NUMBER = 3,
  NAME = 4,
  TWITTER = 5,
  POLL = 6,
  ALLOWLIST = 7,
  PUBLIC_POLL = 8
}

export default class Question {
  id!: number;
  campaignId!: number;
  index!: number;
  type!: CampaignQuestionType;
  text!: string;
  required!: boolean;
  options!: string;

  constructor(
    id: number,
    campaignId: number,
    index: number,
    type: CampaignQuestionType,
    text: string,
    required: boolean,
    options: string
  ) {
    this.id = id;
    this.campaignId = campaignId;
    this.index = index;
    this.type = type;
    this.text = text;
    this.required = required;
    this.options = options;
  }

  static fromJson(data: any) {
    return new Question(
      data.id,
      data.campaignId,
      data.index,
      data.type,
      data.text,
      data.required,
      data.options
    );
  }
}
